// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__39-I9","productName":"Table_productName__2VrrV"};